import { z } from 'zod';
import { storageAllocationsSortByValues } from 'src/apis/storage/mappings';
import {
  descSortDirectionSchema,
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { ssoOptionSchema } from 'src/pages/storage/components/sso-searchable-multi-select';

const commonAllocationsSchema = z.object({
  sortBy: z
    .enum(storageAllocationsSortByValues)
    .default('ALLOCATION_BUSINESS_ID'),
  sortDirection: descSortDirectionSchema,
  offerName: z.string().nullable().default(null),
  allocationBusinessId: z
    .string()
    .regex(/^(STOD-\d+)$/, '{label} must start from "STOD-".')
    .nullable()
    .default(null),
  storageLocationId: z.preprocess(
    preprocessAsArray,
    z.array(formOptionSchema).default([])
  ),
  runtimeStart: z.string().nullable().default(null),
  runtimeEnd: z.string().nullable().default(null),
});

export function getStorageAllocationsForOperatorPageParamsSchema() {
  return z.object({
    ...commonAllocationsSchema.shape,
    shipperOrganisationId: z.preprocess(
      preprocessAsArray,
      z.array(formOptionSchema).default([])
    ),
    ...getPaginationSchema().shape,
  });
}

export function getStorageAllocationsForShipperPageParamsSchema() {
  return z.object({
    ...commonAllocationsSchema.shape,
    ssoOrganisationId: z.preprocess(
      preprocessAsArray,
      z.array(ssoOptionSchema).default([])
    ),
    ...getPaginationSchema().shape,
  });
}
